import { render, staticRenderFns } from "./ContratosForm.vue?vue&type=template&id=4428346c"
import script from "./ContratosForm.vue?vue&type=script&lang=js"
export * from "./ContratosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports